import { KEY } from 'store/booking/types';

export const SET_CORRELATION_ID = `${KEY}.SET_CORRELATION_ID`;
export const CLEAR_CORRELATION_ID = `${KEY}.CLEAR_CORRELATION_ID`;
export const setCorrelationIDAction = () => ({ type: SET_CORRELATION_ID });
export const clearCorrelationIDAction = () => ({ type: CLEAR_CORRELATION_ID });
